import {
  version,
  description
} from '../package'

export default {
  // 版本信息
  releases: {
    version,
    description
  },
}



// WEBPACK FOOTER //
// ./src/setting.js